"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DisclaimerModal;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _modal = _interopRequireDefault(require("@ux/modal"));
var _disclaimer = _interopRequireDefault(require("../disclaimer"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @module DisclaimerModal */

const modalPatch = "pl-mnw44j7";
const modalStyles = "pl-m17jhe06";

/**
 * @ignore
 * @typedef {object} DisclaimerModal
 * @property {string} symbol Annotation symbol
 * @property {string} text Disclaimer section text
 */
/**
 * Render disclaimer modal.
 *
 * @param {object} props React props for element
 * @param {string} props.id The id as required by ux2200 modal
 * @param {string} props.heading Disclaimer modal heading
 * @param {array} props.items Array of disclaimer items
 * @param {string} props.text Text that triggers disclaimer modal
 * @param {string} props.triggerDescription Text below trigger
 * @param {string} props.triggerEid Trigger eid
 * @param {string} props.verticalMargin Vertical Spacing value
 * @returns {React.ReactElement} DisclaimerModal component
 * @public
 */
function DisclaimerModal({
  id,
  _name,
  heading,
  items,
  text,
  triggerDescription,
  triggerEid,
  verticalMargin = 'none',
  ...modalProps
}) {
  const [visible, setVisibility] = (0, _react.useState)(false);
  const symbols = items?.map(item => item?.symbol?.trim()).filter(Boolean).join(', ');
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    className: modalPatch,
    dataCy: "disclaimer-section",
    padding: "large",
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement("p", {
    "data-cy": "disclaimer-modal-container"
  }, /*#__PURE__*/_react.default.createElement(_disclaimer.default, {
    _name: _name,
    text: text,
    symbols: symbols,
    onClick: () => setVisibility(true),
    triggerEid: triggerEid
  })), triggerDescription && /*#__PURE__*/_react.default.createElement("p", {
    "data-cy": "disclaimer-trigger-description"
  }, triggerDescription), visible && /*#__PURE__*/_react.default.createElement(_modal.default, (0, _extends2.default)({
    id: `modal-${id}`,
    title: heading,
    onClose: () => setVisibility(false),
    className: modalStyles,
    "data-cy": "disclaimer-modal"
  }, modalProps), /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.ModalPatch, null), items && items.map((item, i) => /*#__PURE__*/_react.default.createElement("div", {
    key: i,
    id: `id-${item.id}`,
    "data-cy": "disclaimer-item"
  }, item.symbol, " ", item.referenceText?.text, " ", item.text))));
}
DisclaimerModal.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  heading: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    symbol: _propTypes.default.string,
    referenceText: _propTypes.default.shape({
      symbol: _propTypes.default.string,
      text: _propTypes.default.node
    }),
    text: _propTypes.default.node
  })),
  text: _propTypes.default.string,
  triggerDescription: _propTypes.default.string,
  triggerEid: _propTypes.default.string,
  ..._modal.default.propTypes
};